// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ank5xsy9jLAVblAtBGdU{margin-inline-start:5px}", "",{"version":3,"sources":["webpack://./src/templates/multipleAssignButton.module.scss"],"names":[],"mappings":"AAAA,sBACE,uBAAA","sourcesContent":[".container {\n  margin-inline-start: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ank5xsy9jLAVblAtBGdU"
};
export default ___CSS_LOADER_EXPORT___;
